import {createActionWithPayload} from "../utils.actions";
import {PageSize} from "../../../types/common-search";

export const [setAttachedOnlyForceOptions, isSetAttachedOnlyForceOptionsAction] = createActionWithPayload<boolean>('SET_ATTACHED_ONLY_FORCE_OPTIONS');
export const [setQueryForceOptions, isSetQueryForceOptionsAction] = createActionWithPayload<string | undefined>('SET_QUERY_FORCE_OPTIONS');
export const [setSizePageForceOptions, isSetSizePageForceOptionsAction] = createActionWithPayload<PageSize | undefined>('SET_SIZE_PAGE_FORCE_OPTIONS');
export const [setCurrentPageForceOptions, isSetCurrentPageForceOptionsAction] = createActionWithPayload<number | undefined>('SET_CURRENT_PAGE_FORCE_OPTIONS');
